import { FC, ReactNode } from "react";
import { useScreenDimensions } from "@src/hooks/useScreenDimensions";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import { StyleSheet } from "aphrodite";
import Image from "next/image";
import Button from "@src/deprecatedDesignSystem/components/Button";
import Text from "@ui/text";

type Props = {
  children: ReactNode | undefined | null;
};

const MIN_SCREEN_WIDTH = 600;
export const MinScreenSizeWarning: FC<Props> = ({ children }: Props) => {
  const { width } = useScreenDimensions();

  if (width < MIN_SCREEN_WIDTH) {
    return (
      <AutoLayout
        styleDeclaration={styles.container}
        direction="vertical"
        alignmentHorizontal="center"
      >
        <Image
          src={"/images/logo.svg"}
          alt="Opus Logo"
          width={100}
          height={100}
        />

        <Button
          style={{ marginTop: 20 }}
          variant="No Outline"
          text="Download the app"
          rightIcon="arrow-right"
          onClickGoToExternalUrl={"https://t.opus.so/mobile"}
        />

        <Text type="P3" multiline styleDeclaration={styles.description}>
          The Opus dashboard is currently only available through the app.
        </Text>
      </AutoLayout>
    );
  }
  return <>{children}</>;
};

export default MinScreenSizeWarning;

const styles = StyleSheet.create({
  container: {
    background: "#F6F4ED",
    flex: 1,
    paddingBottom: 32,
    paddingTop: "40%",
  },
  description: {
    width: 270,
    marginTop: "auto",
    textAlign: "center",
  },
});
